<template>
  <div class="search-token-item" @click="selectSearchedToken">
    <div class="search-token-item-wrap">
      <div class="option-item option_name">
        <div class="order" v-if="token.order">
          <span :class="{ active: token.order <= 3 }">{{ token.order }}</span>
        </div>
        <div class="token-info-wrap">
          <TokenIcon
            :tokenIcon="token.icon"
            :networkIcon="token.chain_icon"
            :symbol="token.symbol"
          />
          <div class="token-info">
            <div class="pair-wrap">
              <span class="symbol">{{ token.symbol }}</span>
              <img
                :src="copyMobileImg"
                v-clipboard="token.address"
                @click.stop="copySuccess($event, token.address)"
                alt=""
              />
              <span class="name">(</span>
              <span class="name text-ellipsis">{{ token.name }}</span>
              <span class="name">)</span>
            </div>
            <div class="address-wrap" v-if="token.address && !isMobileSize">
              <span class="address">
                {{ token.address.slice(0, 7) + "..." + token.address.slice(-5) }}
              </span>
              <img
                v-if="isCopySuccess"
                :src="correctImg"
                @click.stop="&quot;javascript:void(0)&quot;;"
              />
              <img
                v-else
                :src="copyImg"
                v-clipboard="token.address"
                @click.stop="copySuccess($event, token.address)"
                alt=""
              />
              <!-- <img v-else :src="copyImg" v-clipboard="token.address" v-clipboard:success.stop="copySuccess" alt="" /> -->
            </div>
            <div class="mobile-name text-ellipsis">{{ token.name }}</div>
          </div>
        </div>
      </div>
      <div class="option-item option_price">
        <div class="price">${{ token.price }}</div>
        <div class="chg-price-wrap">
          <div class="chg-1h">
            <span class="title">1H:</span>
            <span
              class="value"
              :class="{
                down: token.chg_1h < 0,
                up: token.chg_1h > 0,
                zero: token.chg_1h == 0,
              }"
            >
              {{ chg1hText }}
            </span>
          </div>
          <div class="chg-24h">
            <span class="title">24H:</span>
            <span
              class="value"
              :class="{
                down: token.chg_24h < 0,
                up: token.chg_24h > 0,
                zero: token.chg_24h == 0,
              }"
            >
              {{ chg24hText }}
            </span>
          </div>
          <div class="chg">
            <span class="value" :class="{ down: token.chg < 0, up: token.chg > 0 }">
              {{ (token.chg > 0 ? "+" : "") + token.chg }}%
            </span>
          </div>
        </div>
      </div>
      <div class="option-item option_liq" v-if="!isMobileSize">
        {{ token.market_value == null ? "-" : "$" + parseWithUnit(token.market_value) }}
      </div>
      <div class="option-item option_vol" v-if="!isMobileSize">
        {{ token.volume == null ? "-" : "$" + parseWithUnit(token.volume) }}
      </div>
      <div class="option-item option_fdv" v-if="!isMobileSize">
        {{ token.market_cap == null ? "-" : "$" + parseWithUnit(token.market_cap) }}
      </div>
      <!-- <div class="option-item option_collect" :class="{ 'option_collect_result': isMobileResult }">
        <Optional @onOptional="onOptional" :token="token" small />
      </div> -->
    </div>
    <div class="mobile-market-value-list" v-if="isMobileSize && marketValueList">
      <div
        class="mobile-market-value-item"
        v-for="(item, index) in token.marketValueList"
        :key="index"
      >
        <span class="title">{{ item.label }}</span>
        <span class="value">${{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TokenIcon from "../common/TokenIcon.vue";
import parseNumber from "../../mixins/parseNumber";
import { PARSE_WITH_UNIT_TYPES } from "../../utils";
import { TRANSIT_DOMAIN } from "../../utils/config";

export default {
  props: {
    token: {
      type: Object,
    },
    small: {
      type: Boolean,
    },
    marketValueList: {
      type: Boolean,
    },
    isMobileResult: {
      type: Boolean,
    },
  },
  components: { TokenIcon },
  mixins: [parseNumber],
  data() {
    return {
      isCopySuccess: false,
    };
  },
  computed: {
    ...mapGetters(["isMobileSize"]),
    chg1hText() {
      if (this.token.chg_1h == null) return "-";
      if (this.token.chg_1h > 0)
        return (
          "+" +
          this.parseWithUnit(this.token.chg_1h, PARSE_WITH_UNIT_TYPES.CHG) +
          "%"
        );
      if (this.token.chg_1h < 0) return this.token.chg_1h + "%";
      return "0%";
    },
    chg24hText() {
      if (this.token.chg_24h == null) return "-";
      if (this.token.chg_24h > 0)
        return (
          "+" +
          this.parseWithUnit(this.token.chg_24h, PARSE_WITH_UNIT_TYPES.CHG) +
          "%"
        );
      if (this.token.chg_24h < 0) return this.token.chg_24h + "%";
      return "0%";
    },
    copyImg() {
      return require(`../../assets/copy/copy-1${this.darkModeImg}.png`);
    },
    copyMobileImg() {
      return require(`../../assets/search-token/copy-m${this.darkModeImg}.png`);
    },
    correctImg() {
      return require(`../../assets/common/correct.png`);
    },
  },
  methods: {
    copySuccess(event, text) {
      if (this.isCopySuccess) return; // 如果已经复制成功，则不再处理
      this.$copyText(text)
        .then(() => {
          this.$notify({ text: this.$t("copied"), type: "success" });
          this.isCopySuccess = true; // 设置复制成功状态
          setTimeout(() => {
            this.isCopySuccess = false;
          }, 2000);
        })
        .catch(() => {
          this.isCopySuccess = false; // 如果复制失败，重置状态
        });
    },
    selectSearchedToken() {
      window.open(
        `${TRANSIT_DOMAIN}/?locale=${this.$i18n.locale}&theme=${this.darkModeTheme}#/chart?chain=${this.token.network}&token=${this.token.address}`,
        '_blank'
      );
    },
    onOptional(token, flag) {
      this.$emit("onOptional", token, flag);
    },
  },
};
</script>

<style lang="less" scoped>
.search-token-item {
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: var(--color-29);
  font-weight: 500;
  cursor: pointer;

  .option-item {
    display: flex;
    align-items: center;
  }
  .option_name {
    flex: var(--search-hot-token-name);
    display: flex;
    align-items: center;
    .order {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      span {
        font-size: 12px;
        color: var(--color-33);
        &.active {
          color: #FF9100;
        }
      }
      img {
        width: 20px;
        height: 20px;
      }
    }

    .token-info-wrap {
      display: flex;
      align-items: center;
      gap: 0 12px;

      /deep/ .token-icon-content {
        width: 40px;
        height: 40px;
        .network-icon {
          border: 1px solid var(--network-icon-border-1);
        }
      }

      .token-info {
        display: flex;
        flex-direction: column;
        gap: 6px 0;
        .pair-wrap {
          display: flex;
          align-items: center;
          color: var(--color-29);
          .symbol {
            font-size: 14px;
            font-weight: 700;
            margin-right: 8px;
          }
          img {
            display: none;
          }
          .name {
            display: inline-block;
            font-size: 13px;
            font-weight: 400;
            max-width: 150px;
            color: var(--color-30);
          }
        }
        .address-wrap {
          display: flex;
          align-items: center;
          gap: 0 2px;
          .address {
            font-size: 12px;
            color: var(--color-27);
            font-weight: 400;
          }
          img {
            width: 12px;
            height: 12px;
            cursor: pointer;
          }
        }
        .mobile-name {
          display: none;
        }
      }
    }
  }

  .option_price {
    flex: var(--search-hot-token-price);
    flex-direction: column;
    align-items: flex-start;
    gap: 4px 0;
    justify-content: center;
    .price {
      font-size: 14px;
      font-weight: 600;
      color: var(--color-29);
    }

    .chg-price-wrap {
      display: flex;
      align-items: center;
      gap: 0 16px;
      font-size: 12px;
      color: var(--color-27);
      font-weight: 400;
      .chg-1h {
        .value {
          &.down {
            color: var(--error-color);
          }
          &.up {
            color: var(--success-color);
          }
          &.zero {
            color: var(--color-1);
          }
        }
      }
      .chg-24h {
        .value {
          &.down {
            color: var(--error-color);
          }
          &.up {
            color: var(--success-color);
          }
          &.zero {
            color: var(--color-1);
          }
        }
      }
      .chg {
        display: none;
      }
    }
  }

  .option_liq {
    flex: var(--search-hot-token-liq);
  }

  .option_vol {
    flex: var(--search-hot-token-24h-vol);
  }

  .option_fdv {
    flex: var(--search-hot-token-fdv);
    display: flex;
    justify-content: flex-end;
  }

  .option_collect {
    flex: var(--search-hot-token-collect);
    display: flex;
    justify-content: flex-end;

    /deep/ .optional-wrap {
      margin-left: 0;
      width: 16px;
      height: 16px;
      .optional {
        width: 16px;
        height: 16px;
      }
    }
  }
  .search-token-item-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;

    // .search-token-item-right {
    //   display: flex;
    //   align-items: center;
    //   gap: 0 16px;
    //   .search-token-item-right-info {
    //     display: flex;
    //     flex-direction: column;
    //     align-items: flex-end;
    //     gap: 7px 0;
    //     .chg-price-wrap {
    //       display: flex;
    //       align-items: center;
    //       gap: 0 16px;
    //       font-size: 12px;
    //       color: var(--color-29);
    //       .chg-1h {
    //         .value {
    //           color: var(--color-1);
    //           font-size: 13px;
    //           font-weight: 500;
    //           &.down {
    //             color: var(--error-color);
    //           }
    //           &.up {
    //             color: var(--success-color);
    //           }
    //         }
    //       }
    //       .chg-24h {
    //         .value {
    //           color: var(--color-1);
    //           font-size: 13px;
    //           font-weight: 500;
    //           &.down {
    //             color: var(--error-color);
    //           }
    //           &.up {
    //             color: var(--success-color);
    //           }
    //         }
    //       }
    //       .chg {
    //         display: none;
    //       }
    //       .price {
    //         font-size: 15px;
    //         font-weight: 600;
    //       }
    //     }
    //     .market-value-list {
    //       display: flex;
    //       gap: 0 8px;
    //       .market-value-item {
    //         display: flex;
    //         align-items: center;
    //         gap: 0 4px;
    //         height: 18px;
    //         // background: #ffffff;
    //         border: 1px solid var(--border-17);
    //         border-radius: 6px;
    //         padding: 0 8px;
    //         font-size: 11px;
    //         .title {
    //           color: var(--color-27);
    //         }
    //         .value {
    //           color: var(--color-29);
    //           font-weight: 500;
    //         }
    //       }
    //     }
    //   }
    //   .collect-img-wrap {
    //     width: 24px;
    //     height: 24px;
    //     background: var(--bg-16);
    //     border-radius: 6px;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     /deep/ .optional-wrap {
    //       margin-left: 0;
    //       width: 16px;
    //       height: 16px;
    //       .optional {
    //         width: 16px;
    //         height: 16px;
    //       }
    //     }
    //   }
    // }
  }
  .mobile-market-value-list {
    display: none;
    .mobile-market-value-item {
      .title {
      }
      .value {
      }
    }
  }
}

@media screen and (max-width: 850px) {
  .search-token-item {
    .option_name {
      .token-info-wrap {
        .token-info {
          .pair-wrap {
            .name {
              max-width: 100px;
            }
          }
        }
      }
    }

    .option_price {
      .chg-price-wrap {
        .chg-1h {
          display: none;
        }
      }
    }
  }
}

@media screen and (max-width: 680px) {
  .search-token-item {
    padding: 0;

    .option_name {
      .order {
        width: 30px;
        height: 30px;

        span {
          font-size: 13px;
        }
      }

      .token-info-wrap {
        display: flex;
        align-items: center;
        gap: 0 10px;
  
        /deep/ .token-icon-content {
          width: 38px;
          height: 38px;
          .network-icon {
            width: 13px;
            height: 13px;
            border: 2px solid var(--network-icon-border-1);
          }
        }

        .token-info {
          gap: 2px 0;
          .pair-wrap {
            display: flex;
            align-items: center;
            gap: 0 4px;
            .symbol {
              font-size: 13px;
              margin-right: 0;
              font-weight: 500;
            }
            img {
              display: inline-block;
              display: none;
              width: 16px;
              height: 16px;
            }
            .name {
              display: none;
            }
          }
          .address-wrap {
            display: none;
          }
          .mobile-name {
            display: inline-block;
            font-size: 11px;
            color: var(--color-30);
            max-width: 120px;
          }
        }
      }
    }

    .option_price {
      display: flex;
      align-items: flex-end;
      gap: 2px 0;

      .price {
        font-size: 13px;
      }

      .chg-price-wrap {
        flex-direction: column;
        align-items: flex-end;
        gap: 4px 0;
        font-size: 10px;
        .chg-1h {
          display: none;
        }
        .chg-24h {
          display: none;
        }
        .chg {
          order: 2;
          display: flex;
          .value {
            color: var(--color-1);
            font-weight: 500;
            font-size: 11px;
            &.down {
              color: var(--error-color);
            }
            &.up {
              color: var(--success-color);
            }
          }
        }
        .price {
          order: 1;
          font-weight: 600;
        }
      }
    }

    .option_collect {
      &.option_collect_result {
        margin-left: 12px;
        flex: none;
      }
    }
      
    .search-token-item-wrap {
      .search-token-item-name {
        .token-info {
          .pair-wrap {
            display: flex;
            align-items: center;
            gap: 0 4px;
            .symbol {
              font-size: 14px;
              margin-right: 0;
            }
            img {
              display: inline-block;
              width: 16px;
              height: 16px;
            }
            .name {
              display: none;
            }
          }
          .address-wrap {
            display: none;
          }
          .mobile-name {
            display: inline-block;
            font-size: 11px;
            color: var(--color-30);
            max-width: 120px;
          }
        }
      }
      .search-token-item-right {
        gap: 0 10px;
        .search-token-item-right-info {
          .chg-price-wrap {
            flex-direction: column;
            align-items: flex-end;
            gap: 4px 0;
            font-size: 10px;
            .chg-1h {
              display: none;
            }
            .chg-24h {
              display: none;
            }
            .chg {
              order: 2;
              display: flex;
              .value {
                color: var(--color-1);
                font-weight: 500;
                font-size: 11px;
                &.down {
                  color: var(--error-color);
                }
                &.up {
                  color: var(--success-color);
                }
              }
            }
            .price {
              order: 1;
              font-weight: 600;
            }
          }
          .market-value-list {
            display: none;
          }
        }
        .collect-img-wrap {
          width: 24px;
          height: 24px;
          // background: #f9f9f9;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          /deep/ .optional-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 0;
            width: 100%;
            height: 100%;
            .optional {
              width: 16px;
              height: 16px;
            }
            .optional-mobile {
              display: none;
            }
          }
        }
      }
    }
    .mobile-market-value-list {
      // margin-left: 46px;
      margin-top: 8px;
      display: flex;
      justify-content: flex-end;
      height: 24px;
      border-radius: 6px;
      gap: 0 6px;
      .mobile-market-value-item {
        border: 1px solid var(--border-19);
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0 6px;
        position: relative;
        font-size: 11px;
        border-radius: 4px;
        .title {
          color: var(--color-27);
        }
        .value {
          color: var(--color-29);
          font-weight: 400;
        }
        // &:not(:last-child)::before {
        //   content: "";
        //   width: 1px;
        //   height: 12px;
        //   position: absolute;
        //   right: 0;
        //   top: 50%;
        //   transform: translateY(-50%);
        //   background-color: var(--bg-13);
        // }
      }
    }
  }
}
</style>
